import { TUserUiPreferences } from '@/shared/types/ui-preferences.types';

// Fixed key order so two preference sets compare equal by string.
export const serializeUiPreferences = (
  preferences: TUserUiPreferences,
): string =>
  JSON.stringify({
    language: preferences.language ?? null,
    theme: preferences.theme ?? null,
    dateTimeFormat: preferences.dateTimeFormat ?? null,
    temperatureUnit: preferences.temperatureUnit ?? null,
  });
